import { IAlertState } from '@store/alerts/types';
import { createDeferredAction } from '@store/common/actions';
import { httpRequestFactory } from '@store/common/http-request-factory';
import { HttpRequestMethod } from '@store/common/http-request-method';
import { MAIN_API } from '@store/common/path';
import { AxiosResponse } from 'axios';
import { logError } from 'core/sentry';
import { INotificationPreference } from 'lingopractices-models';
import { SagaIterator } from 'redux-saga';
import { call, put } from 'redux-saga/effects';

import { GetAlertsSuccess } from './get-alerts-success';

export class GetAlerts {
  static get action() {
    return createDeferredAction('notifications/GET_NOTIFICATION_PREFERENCES');
  }

  static get reducer() {
    return (draft: IAlertState) => {
      draft.requests.getNotificationsPending = true;

      return draft;
    };
  }

  static get saga() {
    return function* ({ meta }: ReturnType<typeof GetAlerts.action>): SagaIterator {
      try {
        const { data } = GetAlerts.httpRequest.call(
          yield call(() => GetAlerts.httpRequest.generator()),
        );

        yield put(GetAlertsSuccess.action(data));
      } catch (e: any) {
        meta?.deferred.reject(e);
        logError(e);
      }
    };
  }

  static get httpRequest() {
    return httpRequestFactory<AxiosResponse<INotificationPreference[]>, undefined>(
      MAIN_API.NOTIFICATIONS_PREFERENCES,
      HttpRequestMethod.Get,
    );
  }
}
